import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../auth.service';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.user();

  if (user?.role === 'ADMIN') {
    return true;
  }

  // Redirect non-admins to exercises
  return router.createUrlTree(['/exercises']);
};
